import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { createClassNames } from '../core/utils';
import Highlighter from './Highlighter';
var cx = createClassNames('Snippet');

var Snippet = function Snippet(props) {
  return React.createElement(Highlighter, _extends({}, props, {
    highlightProperty: "_snippetResult",
    cx: cx
  }));
};

export default Snippet;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-dom/dist/es/components/Snippet.js
// module id = 1032
// module chunks = 0 1 2 3 4 5 6 7 8